export type ShopItemKind = 'raw' | 'refined' | 'consumable' | 'upgrade' | 'drone' | 'other';

export type ShopFilterId = 'all' | ShopItemKind;

export const SHOP_FILTER_CHIPS: ReadonlyArray<{ id: ShopFilterId; label: string }> = [
  { id: 'all', label: 'All' },
  { id: 'raw', label: 'Raw' },
  { id: 'refined', label: 'Refined' },
  { id: 'consumable', label: 'Consumables' },
  { id: 'upgrade', label: 'Upgrades' },
  { id: 'drone', label: 'Drones' }
];

export type ShopFilterItem = { name: string; kind: ShopItemKind; held: number };

export type ShopFilterState = { filter: ShopFilterId; searchText: string; inHoldOnly: boolean };

export const createShopFilterState = (): ShopFilterState => ({ filter: 'all', searchText: '', inHoldOnly: false });

/** Case-insensitive substring match on the item name; an empty query matches everything. */
export const matchesSearchText = (name: string, searchText: string): boolean => {
  const query = searchText.trim().toLowerCase();
  return query.length === 0 || name.toLowerCase().includes(query);
};

/**
 * Same precedence as the storage room: when a search is typed it replaces the type chip (so a search always
 * looks across everything); the "in hold" toggle applies on top of either.
 */
export const matchesShopFilter = (item: ShopFilterItem, state: ShopFilterState): boolean => {
  if (state.inHoldOnly && item.held <= 0) return false;
  if (state.searchText.trim().length > 0) return matchesSearchText(item.name, state.searchText);
  return state.filter === 'all' || item.kind === state.filter;
};

/** Which chips have at least one item in `items` (plus 'all'), so empty categories can be hidden. */
export const availableShopFilters = (items: ReadonlyArray<Pick<ShopFilterItem, 'kind'>>): Set<ShopFilterId> => {
  const found = new Set<ShopFilterId>(['all']);
  for (const item of items) found.add(item.kind);
  return found;
};
